/* Mystery Pack rip engine (Rich 10-18, approved mockup Adonis/mockups/mystery-box/rip).
 *
 * window.MysteryRip:
 *   pack(stageEl, opts)   one sealed pack the customer rips by dragging across the top (finger or mouse).
 *                         The tear has already started at the top-left corner; no light or colour shows until
 *                         the strip is all the way off. opts: {pack, back, rc, seed, demo, onRip}
 *                         Returns {rip(), peek(), reveal(frontEl, done), stage, card}.
 *   face(row, mini)       the collectible card for a pull (blue / purple / gold foil). No animated light, ever.
 *   share(kind, data)     draws a 9:16 story image on a canvas and opens the phone's share sheet (or saves it).
 *
 * Nothing here decides a pull: the server drew it at payment. This only shows it.
 */
(function () {
  'use strict';
  var TEAR = 10.4;                       // % down the pack where it tears
  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function img(u, w) { return u ? esc(u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w) : ''; }
  function tierClass(stars) { return stars >= 3 ? 't-legendary' : stars === 2 ? 't-rare' : 't-common'; }
  function rc(stars) { return stars >= 3 ? '242,179,61' : stars === 2 ? '155,92,246' : '47,125,246'; }
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* one jagged tear line shared by the body (below) and the strip (above) so they fit back together */
  function tearPoints(seed) {
    var s = seed, pts = [];
    function r() { s = (s * 9301 + 49297) % 233280; return s / 233280; }
    for (var i = 0; i <= 24; i++) pts.push([i / 24 * 100, TEAR + (i % 2 ? 1.1 : -0.9) * (0.6 + r() * 0.8)]);
    return pts;
  }
  function yAt(pts, X) {
    for (var i = 1; i < pts.length; i++) if (pts[i][0] >= X) {
      var a = pts[i - 1], b = pts[i], f = (X - a[0]) / (b[0] - a[0] || 1); return a[1] + (b[1] - a[1]) * f;
    }
    return pts[pts.length - 1][1];
  }
  function pt(q) { return q[0] + '% ' + q[1] + '%'; }
  /* the strip split where the tear has reached (X%): the torn flap to the left, the still-sealed part to the right */
  function stripPart(pts, X, side) {
    var y = yAt(pts, X), below;
    if (side === 'flap') {
      below = pts.filter(function (q) { return q[0] < X; }).reverse().map(pt);
      return 'polygon(0 0,' + X + '% 0,' + X + '% ' + y + '%,' + below.join(',') + ')';
    }
    below = pts.filter(function (q) { return q[0] > X; }).reverse().map(pt);
    return 'polygon(' + X + '% 0,100% 0,' + below.join(',') + ',' + X + '% ' + y + '%)';
  }
  function bodyClip(pts) { return 'polygon(' + pts.map(pt).join(',') + ',100% 100%,0 100%)'; }

  function face(r, mini) {
    var cls = tierClass(r.stars || 1);
    return '<div class="' + (mini ? 'rp-mini ' : '') + 'rp-art ' + cls + '"><div class="rp-gi">' +
      '<img class="rp-bg" alt="" src="' + img(r.image, 360) + '"><img class="rp-photo" alt="" src="' + img(r.image, mini ? 240 : 600) + '">' +
      '<span class="rp-tx">' + (mini ? '<span class="rp-gem"></span>' : '<span class="rp-tier">' + esc(String(r.tier || '').toUpperCase()) + '</span>') +
      '<span class="rp-name">' + esc(r.title) + '</span>' + (!mini && r.vendor ? '<span class="rp-by">by ' + esc(r.vendor) + '</span>' : '') + '</span></div></div>';
  }

  function pack(stage, o) {
    var pts = tearPoints(o.seed || 11);
    stage.classList.add('rp-stage');
    stage.classList.remove('is-ripped', 'is-dragging');
    stage.style.height = '';
    stage.style.setProperty('--rc', o.rc || '255,255,255');
    stage.innerHTML =
      '<div class="rp-say">The tear’s started. <b>Pull it across</b></div>' +
      (o.deck || '') +
      '<div class="rp-pk">' +
        '<div class="rp-card"><div class="rp-in"><div class="rp-face rp-back" style="background-image:url(\'' + esc(o.back) + '\')"><span class="rp-q">?</span></div><div class="rp-face" data-rp-front></div></div></div>' +
        '<span class="rp-gap"></span>' +
        '<img class="rp-part rp-body" alt="" src="' + esc(o.pack) + '" style="clip-path:' + bodyClip(pts) + '">' +
        '<img class="rp-part rp-rest" alt="" src="' + esc(o.pack) + '">' +
        '<img class="rp-part rp-flap" alt="" src="' + esc(o.pack) + '">' +
        '<span class="rp-hint"></span>' +
        '<div class="rp-grab" tabindex="0" role="button" aria-label="Rip the pack open: drag across the top, or press Enter"></div>' +
      '</div>';
    var pk = stage.querySelector('.rp-pk'), flap = stage.querySelector('.rp-flap'), rest = stage.querySelector('.rp-rest'),
        gap = stage.querySelector('.rp-gap'), grab = stage.querySelector('.rp-grab'), card = stage.querySelector('.rp-card'),
        hint = stage.querySelector('.rp-hint');
    var start = null, p = 0, done = false, touched = false, timer = null;

    function setP(v) {
      p = Math.max(0, Math.min(1, v));
      var X = Math.min(100, 24 + p * 76);           // the tear starts a quarter of the way across
      flap.style.clipPath = stripPart(pts, X, 'flap');
      rest.style.clipPath = X >= 100 ? 'polygon(0 0,0 0,0 0)' : stripPart(pts, X, 'rest');
      flap.style.transformOrigin = X + '% ' + yAt(pts, X) + '%';
      flap.style.transform = 'translateY(' + (-0.8 - p * 3) + '%) rotate(' + (16 + p * 14) + 'deg)';   // the free end lifts toward the pull
      if (!done) gap.style.opacity = 0;             // no light until the tear is all the way across
    }
    setP(0);

    // a fingertip shows the move every few seconds until they grab it
    function demo() {
      if (touched || done || still || o.demo === false || !stage.isConnected) return;
      var w = pk.getBoundingClientRect().width, t0 = performance.now();
      hint.style.opacity = 1;
      (function step(now) {
        if (touched || done) { hint.style.opacity = 0; return; }
        var t = (now - t0) / 1500, k = t < .55 ? Math.sin(t / .55 * Math.PI / 2) : Math.max(0, 1 - (t - .55) / .45);
        setP(k * 0.28); hint.style.transform = 'translateX(' + (k * 0.28 * 0.76 * w) + 'px)';
        if (t < 1) requestAnimationFrame(step); else { setP(0); hint.style.opacity = 0; hint.style.transform = ''; }
      })(t0);
    }
    if (o.demo !== false) { setTimeout(demo, 700); timer = setInterval(demo, 3600); }

    grab.addEventListener('pointerdown', function (e) {
      if (done) return;
      touched = true; clearInterval(timer); hint.style.opacity = 0;
      start = {x: e.clientX, w: pk.getBoundingClientRect().width};
      try { grab.setPointerCapture(e.pointerId); } catch (err) {}
      stage.classList.add('is-dragging'); flap.classList.remove('is-back', 'is-fly');
      if (o.onPull) o.onPull(true);
    });
    grab.addEventListener('pointermove', function (e) {
      if (!start || done) return;
      setP(Math.abs(e.clientX - start.x) / (start.w * 0.75));
      if (p >= 1) rip();
    });
    function up() {
      if (!start || done) return;
      start = null; stage.classList.remove('is-dragging');
      if (o.onPull) o.onPull(false);
      if (p > 0.6) rip(); else { flap.classList.add('is-back'); setP(0); }
    }
    grab.addEventListener('pointerup', up);
    grab.addEventListener('pointercancel', up);
    grab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); rip(); } });

    function rip() {
      if (done) return; done = true; start = null; clearInterval(timer);
      try { if (navigator.vibrate) navigator.vibrate(25); } catch (e) {}
      stage.classList.add('is-ripped'); stage.classList.remove('is-dragging');
      if (o.onPull) o.onPull(false);
      flap.classList.add('is-fly');
      setP(1); rest.style.opacity = 0;
      requestAnimationFrame(function () { flap.style.transform = 'translate(85%,-30%) rotate(70deg)'; flap.style.opacity = 0; });   // leaves sideways, never over the text
      gap.style.transition = 'opacity .6s'; gap.style.opacity = 1;
      grab.remove();
      if (o.onRip) o.onRip();
    }
    // practice: the "?" card peeks out of the open pack
    function peek() { setTimeout(function () { card.style.transform = 'translateY(-60%) rotate(-3deg)'; gap.style.opacity = .5; }, 260); }
    /* the real pull, like a real pack: the pack is drawn down while the card slides up until it is completely clear
       of the opening; only then does it come forward and grow, while the empty pack fades away; then it flips */
    function reveal(r, then) {
      var front = stage.querySelector('[data-rp-front]');
      front.className = 'rp-face rp-art ' + tierClass(r.stars || 1);
      front.innerHTML = face(r).replace(/^<div class="[^"]*">/, '').replace(/<\/div>$/, '');
      stage.style.setProperty('--rc', rc(r.stars || 1));
      var pkH = pk.offsetHeight, ch = card.offsetHeight;
      var rise = 0.19 * pkH + ch - 0.104 * pkH + 8, D = Math.round(rise * 0.55);
      pk.style.transition = 'transform .9s cubic-bezier(.3,.7,.3,1)';
      var wait = still ? [0, 0, 0, 0] : [250, 1250, 2150, 2950];
      setTimeout(function () { pk.style.transform = 'translate(-50%,' + D + 'px)'; card.style.transform = 'translateY(' + (-rise) + 'px)'; }, wait[0]);
      setTimeout(function () {
        card.style.zIndex = 9;
        Array.prototype.forEach.call(stage.querySelectorAll('.rp-part,.rp-gap'), function (el) { el.style.transition = 'opacity .5s'; el.style.opacity = 0; });
        var base = 64 + D + 0.19 * pkH + ch / 2;
        card.style.transform = 'translateY(' + (165 - base) + 'px) scale(1.5)';
        if (o.shrink !== false) stage.style.height = '318px';
      }, wait[1]);
      setTimeout(function () { card.classList.add('is-flip'); if (then) then('flip'); }, wait[2]);
      setTimeout(function () { if (then) then('done'); }, wait[3]);
    }
    return {stage: stage, card: card, rip: rip, peek: peek, reveal: reveal, stop: function () { clearInterval(timer); touched = true; }};
  }

  /* ---- share images (story size 1080 x 1920): one headline, one picture, the logo ---- */
  var FONT = '-apple-system, "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif';
  function load(src) {
    return new Promise(function (ok) {
      if (!src) return ok(null);
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { ok(im); }; im.onerror = function () { ok(null); };
      im.src = src;
    });
  }
  function rr(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
  function cover(ctx, im, x, y, w, h) {
    if (!im) return;
    var s = Math.max(w / im.width, h / im.height), sw = w / s, sh = h / s;
    ctx.drawImage(im, (im.width - sw) / 2, (im.height - sh) / 2, sw, sh, x, y, w, h);
  }
  var FOIL = {
    1: ['#0c2a66', '#8fbaff', '#1d4fb8', '#d6e6ff', '#1a47a8', '#8fbaff', '#0b2257'],
    2: ['#2a0d63', '#d2b4ff', '#5b2bc0', '#f3e9ff', '#4b22a6', '#b48cff', '#220a52'],
    3: ['#7a5a14', '#f9e7a1', '#b98a2c', '#fff4c2', '#a77a22', '#f3d77f', '#6e4f10']
  };
  var NAMECOL = {1: '#d6e6ff', 2: '#eadcff', 3: '#f6d77a'};
  function drawCard(ctx, x, y, w, r, photo) {
    var h = w * 88 / 63, n = Math.max(1, Math.min(3, r.stars || 1)), c = rc(n);
    ctx.save();
    ctx.shadowColor = 'rgba(' + c + ',.55)'; ctx.shadowBlur = w * .25;
    var g = ctx.createLinearGradient(x, y, x + w, y + h);
    FOIL[n].forEach(function (col, i, a) { g.addColorStop(i / (a.length - 1), col); });
    rr(ctx, x, y, w, h, w * .06); ctx.fillStyle = g; ctx.fill();
    ctx.restore();
    var p = w * .035, ix = x + p, iy = y + p, iw = w - 2 * p, ih = h - 2 * p;
    ctx.save(); rr(ctx, ix, iy, iw, ih, w * .04); ctx.clip();
    ctx.fillStyle = '#000'; ctx.fillRect(ix, iy, iw, ih);
    if (photo) { ctx.filter = 'blur(' + Math.round(w * .05) + 'px) brightness(.6)'; cover(ctx, photo, ix - iw * .1, iy - ih * .1, iw * 1.2, ih * 1.2); ctx.filter = 'none'; }
    var sh = ctx.createLinearGradient(0, iy, 0, iy + ih);
    sh.addColorStop(.45, 'rgba(0,0,0,0)'); sh.addColorStop(.65, 'rgba(0,0,0,.55)'); sh.addColorStop(1, 'rgba(0,0,0,.92)');
    ctx.fillStyle = sh; ctx.fillRect(ix, iy, iw, ih);
    var aw = iw - w * .08, ah = aw * 9 / 16, ax = ix + w * .04, ay = iy + w * .1;
    ctx.save(); rr(ctx, ax, ay, aw, ah, w * .025); ctx.clip(); cover(ctx, photo, ax, ay, aw, ah); ctx.restore();
    ctx.strokeStyle = 'rgba(255,255,255,.55)'; ctx.lineWidth = 2; rr(ctx, ax, ay, aw, ah, w * .025); ctx.stroke();
    ctx.textAlign = 'center';
    var label = String(r.tier || '').toUpperCase(), fs = w * .045;
    ctx.font = '800 ' + fs + 'px ' + FONT;
    var lw = ctx.measureText(label).width + fs * 2.2, ly = iy + ih - w * .43;
    rr(ctx, x + w / 2 - lw / 2, ly, lw, fs * 1.9, fs * .35); ctx.fillStyle = FOIL[n][3]; ctx.fill();
    ctx.fillStyle = FOIL[n][6]; ctx.fillText(label.split('').join(String.fromCharCode(8202)), x + w / 2, ly + fs * 1.33);
    ctx.font = '800 ' + (w * .12) + 'px ' + FONT; ctx.fillStyle = NAMECOL[n];
    var name = String(r.title || ''); while (ctx.measureText(name).width > iw * .92 && name.length > 4) name = name.slice(0, -2) + '…';
    ctx.fillText(name, x + w / 2, iy + ih - w * .16);
    if (r.vendor) { ctx.font = '500 ' + (w * .055) + 'px ' + FONT; ctx.fillStyle = 'rgba(255,255,255,.75)'; ctx.fillText('by ' + r.vendor, x + w / 2, iy + ih - w * .07); }
    ctx.restore();
  }
  function share(kind, d) {
    var W = 1080, H = 1920, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d'), best = d.best || {}, n = Math.max(1, Math.min(3, best.stars || 1));
    var fontReady = (document.fonts && document.fonts.load) ? document.fonts.load('120px "bestia-display"').catch(function () {}) : Promise.resolve();
    return Promise.all([load(d.pack), load(d.logo), fontReady, load(best.image ? best.image + (best.image.indexOf('?') < 0 ? '?' : '&') + 'width=900' : '')]).then(function (ims) {
      var packIm = ims[0], logo = ims[1], photo = ims[3];
      ctx.fillStyle = '#050506'; ctx.fillRect(0, 0, W, H);
      var glow = ctx.createRadialGradient(W / 2, 820, 0, W / 2, 820, 700);
      glow.addColorStop(0, kind === 'sealed' ? 'rgba(255,255,255,.16)' : 'rgba(' + rc(n) + ',.4)'); glow.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);
      // the "Rip it." wordmark on every share image (Bestia + rarity gradient + glow)
      ctx.save(); ctx.translate(W / 2, 200); ctx.rotate(-4 * Math.PI / 180);
      ctx.font = '130px "bestia-display", ' + FONT; ctx.textAlign = 'center';
      var mw = ctx.measureText('Rip it.').width, mg = ctx.createLinearGradient(-mw / 2, 0, mw / 2, 0);
      mg.addColorStop(0, '#2F7DF6'); mg.addColorStop(.5, '#9B5CF6'); mg.addColorStop(1, '#F2B33D');
      ctx.lineJoin = 'round'; ctx.lineWidth = 6; ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.shadowColor = 'rgba(255,255,255,.45)'; ctx.shadowBlur = 5;
      ctx.strokeText('Rip it.', 0, 0);                     // glowing rim
      ctx.shadowBlur = 0; ctx.fillStyle = mg; ctx.fillText('Rip it.', 0, 0); ctx.restore();   // crisp letters on top
      ctx.textAlign = 'center'; ctx.fillStyle = '#fff'; ctx.font = '700 72px ' + FONT;
      var accent = 'rgb(' + rc(n) + ')';
      if (kind === 'sealed') {
        ctx.fillText(d.count === 1 ? 'Ripping my pack.' : d.count + ' packs to rip.', W / 2, 400);
        var N = Math.min(d.count || 1, 10), pw = 330, ph = pw * 1242 / 920;
        var order = []; for (var k0 = 0; k0 < N; k0++) order.push(k0 - (N - 1) / 2);
        order.sort(function (a, b) { return Math.abs(b) - Math.abs(a); });   // outside packs first, the middle one on top
        for (var k = 0; k < N; k++) {
          var c = order[k];
          ctx.save(); ctx.translate(W / 2 + c * 24, 760 + ph * 1.5 + Math.abs(c) * 7); ctx.rotate(c * 3 * Math.PI / 180);
          ctx.shadowColor = 'rgba(0,0,0,.8)'; ctx.shadowBlur = 40;
          if (packIm) ctx.drawImage(packIm, -pw / 2, -ph * 1.5, pw, ph);
          ctx.restore();
        }
      } else {
        var lines = kind === 'haul' ? ['Best pull:', best.tier + '.'] : ['I pulled a', best.tier + '.'];
        ctx.fillText(lines[0], W / 2, 380); ctx.fillStyle = accent; ctx.fillText(lines[1], W / 2, 470);
        drawCard(ctx, W / 2 - 260, 580, 520, best, photo);
        if (kind === 'haul' && d.all) {
          var m = d.all.length, gap = 34, x0 = W / 2 - (m - 1) * gap / 2;
          d.all.forEach(function (s, i) {
            ctx.beginPath(); ctx.arc(x0 + i * gap, 1400, 11, 0, Math.PI * 2);
            ctx.fillStyle = 'rgb(' + rc(s) + ')'; ctx.shadowColor = 'rgba(' + rc(s) + ',.8)'; ctx.shadowBlur = 16; ctx.fill(); ctx.shadowBlur = 0;
          });
        }
      }
      if (logo) { var lw2 = 300, lh = lw2 * logo.height / logo.width; ctx.drawImage(logo, W / 2 - lw2 / 2, H - 300, lw2, lh); }
      ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.font = '500 30px ' + FONT; ctx.fillText(d.url || 'theonlinemagicstore.com/pack', W / 2, H - 120);
      return new Promise(function (ok) { cv.toBlob(ok, 'image/png'); });
    }).then(function (blob) {
      var file = new File([blob], 'my-mystery-pack.png', {type: 'image/png'});
      if (navigator.canShare && navigator.canShare({files: [file]})) {
        return navigator.share({files: [file], text: d.text || 'theonlinemagicstore.com/pack'}).catch(function () {});
      }
      var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = file.name;
      document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    });
  }

  // show the "Rip it." mark only once its font is in (never a flash of the stand-in font); give up after 3s
  (function () {
    var done = function () { document.documentElement.classList.add('rip-ready'); };
    if (!document.fonts || !document.fonts.load) return done();
    setTimeout(done, 3000);
    document.fonts.load('40px "bestia-display"').then(done, done);
  })();
  window.MysteryRip = {pack: pack, face: face, share: share, rc: rc, tierClass: tierClass};
}());
